import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  FirmwareUpdateNotification,
  FirmwareUpdateNotificationService,
} from '../../services/firmware-update-notification.service';

@Component({
  selector: 'app-firmware-update-notifications',
  standalone: false,
  template: `
    <div
      *ngFor="let notification of notifications; trackBy: trackByNotificationId"
      class="firmware-update-notification"
    >
      <notification-alert
        type="success"
        [title]="getNotificationTitle(notification)"
        [message]="getNotificationMessage(notification)"
        cssClass="firmware-update-alert"
        [id]="'firmware-notification-' + notification.id"
      >
        <button
          mat-icon-button
          class="close-button"
          (click)="dismissNotification(notification.id)"
          aria-label="Dismiss notification"
        >
          <mat-icon>close</mat-icon>
        </button>
      </notification-alert>
    </div>
  `,
  styles: [
    `
      .firmware-update-notification {
        margin-bottom: 16px;
      }

      .firmware-update-alert {
        position: relative;
      }

      .close-button {
        position: absolute;
        top: 8px;
        right: 8px;
        width: 32px;
        height: 32px;
        line-height: 32px;
      }
    `,
  ],
})
export class FirmwareUpdateNotificationsComponent implements OnInit {
  notifications: FirmwareUpdateNotification[] = [];
  private readonly destroyRef = inject(DestroyRef);

  constructor(
    public readonly firmwareUpdateNotificationService: FirmwareUpdateNotificationService,
  ) {}

  ngOnInit(): void {
    this.firmwareUpdateNotificationService.notifications$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((notifications) => {
        this.notifications = notifications;
      });
  }

  getNotificationTitle(notification: FirmwareUpdateNotification): string {
    if (notification.type === 'single') {
      return `Firmware update sent to ${notification.displayName}`;
    } else {
      return `Firmware updates sent to ${notification.displayCount} displays`;
    }
  }

  getNotificationMessage(notification: FirmwareUpdateNotification): string {
    return "Your display is updating in the background — no action needed. You can leave this page at any time. To confirm the update, check the last firmware update date in your LG display's settings.";
  }

  dismissNotification(notificationId: string): void {
    this.firmwareUpdateNotificationService.removeNotification(notificationId);
  }

  trackByNotificationId(
    index: number,
    notification: FirmwareUpdateNotification,
  ): string {
    return notification.id;
  }
}
